import React, { useState } from 'react';
import {
	Typography,
	Box,
	Grid,
	TextField,
	Button,
	CircularProgress,
} from '@material-ui/core';
import {
	BLACK_COLOR,
	WHITE_COLOR,
	GRAY_HIGHLIGHT,
	DEBIT_RED,
	CREDIT_GREEN,
} from '../../constants/color';
import usersApi from '../../apis/usersApi';

export default function AddBanner({ handleClose }) {
	const [isSending, setIsSending] = useState(false);
	const [status, setStatus] = useState('');
	const [payload, setPayload] = useState({
		content: '',
		title: '',
		url: '',
	});
	const [isDeleting, setIsDeleting] = useState(false);

  const disabled = !payload.title || !payload.content

	const onSend = async () => {
		if (disabled) return;
		setStatus('');
		setIsSending(true);
		try {
			await usersApi.createBanner(payload);
			setStatus('Banner created successfully');
			setPayload({ ...payload, title: '', content: '', url: '' });
		} catch (error) {
			console.log(error);
			setStatus(
				'Error: There was an issue with your request, please try again'
			);
		} finally {
			setIsSending(false);
		}
	};

	const onDelete = async () => {
		setIsDeleting(true);
		try {
			await usersApi.deleteBanner();
			setStatus('Banner deleted successfully');
			setPayload({ ...payload, content: '', title: '', url: '' });
		} catch (error) {
			console.log(error);
			setStatus(
				'Error: There was an issue with your request, please try again'
			);
		} finally {
			setIsDeleting(false);
		}
	};

	return (
		<div>
			<Box
				display='flex'
				width={{ xs: '80vw', sm: '60vw', md: '50vw' }}
				fullWidth
				height={84}
				justifyContent='space-between'
				alignItems='flex-start'
			>
				<Typography
					variant='h5'
					style={{
						fontFamily: 'HelveticaNeue-Bold',
						marginTop: 10,
					}}
				>
					Create Banner
				</Typography>

				<Typography
					onClick={handleClose}
					style={{ cursor: 'pointer', color: GRAY_HIGHLIGHT }}
				>
					<span
						role='img'
						aria-label='close'
					>
						✕
					</span>
				</Typography>
			</Box>
			<>
				{status && (
					<Typography
						variant='subtitle2'
						style={{
							// fontFamily: "HelveticaNeue-Bold",
							// fontSize: 10,
							marginBottom: 40,
							color: status.toLowerCase().startsWith('error')
								? DEBIT_RED
								: CREDIT_GREEN,
						}}
					>
						{status}
					</Typography>
				)}
				<Box mb={2}>
					<Grid container>
						<Grid
							item
							xs={12}
						>
							<TextField
								type='text'
								label='Link'
								placeholder='e.g. '
								variant='outlined'
								size='small'
								fullWidth
								InputLabelProps={{
									shrink: false,
								}}
								value={payload.url}
								onChange={(e) => {
									setPayload({ ...payload, url: e.target.value });
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<TextField
								type='text'
								label='Enter Banner Title'
								placeholder='e.g. '
								variant='outlined'
								size='small'
								fullWidth
								InputLabelProps={{
									shrink: false,
								}}
								value={payload.title}
								onChange={(e) => {
									setPayload({ ...payload, title: e.target.value });
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<TextField
								id='outlined-multiline-static'
								label='Enter Banner Description'
								multiline
								rows='4'
								variant='outlined'
								fullWidth
								InputLabelProps={{
									shrink: false,
								}}
								value={payload.content}
								onChange={(e) => {
									setPayload({ ...payload, content: e.target.value });
								}}
							/>
						</Grid>
					</Grid>
				</Box>
				<Box
					display='flex'
					justifyContent='space-between'
				>
					<Button
						variant='contained'
						size='large'
						component='span'
						disableElevation
						disabled={isSending || isDeleting}
						style={{
							fontSize: 12,
							fontWeight: 'bold',
							backgroundColor: DEBIT_RED,
							color: WHITE_COLOR,
							borderRadius: 25,
							paddingLeft: 35,
							paddingRight: 35,
							opacity: isSending || isDeleting ? 0.7 : 1,
						}}
						onClick={onDelete}
					>
						{isDeleting ? (
							<CircularProgress
								disableShrink
								size={18}
								color='inherit'
								// style={{ marginLeft: 37, marginRight: 37 }}
							/>
						) : (
							<>Clear</>
						)}
					</Button>
					<Button
						variant='contained'
						size='large'
						component='span'
						disableElevation
						disabled={disabled || isSending || isDeleting}
						style={{
							fontSize: 12,
							fontWeight: 'bold',
							backgroundColor: BLACK_COLOR,
							color: WHITE_COLOR,
							borderRadius: 25,
							paddingLeft: 35,
							paddingRight: 35,
							opacity: disabled ? 0.7 : 1,
						}}
						onClick={onSend}
					>
						{isSending ? (
							<CircularProgress
								disableShrink
								size={18}
								color='inherit'
								// style={{ marginLeft: 37, marginRight: 37 }}
							/>
						) : (
							<>Send</>
						)}
					</Button>
				</Box>
			</>
		</div>
	);
}
